import { Col, Row } from 'antd';
import React from 'react';
import { HelpingRoutes, PageRoute } from '../../../models';
import { NavLink } from '../NavLink';
import styles from './HelpSectionDesktop.scss';

const HelpSectionDesktop = () => (
  <Row>
    <Col xs={24} sm={24} md={12} lg={12} xl={12} className={styles.column}>
      <NavLink
        title={"Uvjeti korištenja"}
        path={`${PageRoute.help}/${HelpingRoutes.termsOfUse}`}
      />

      <NavLink
        title={"Banner oglašavanje"}
        path={`${PageRoute.help}/${HelpingRoutes.advertising}`}
      />

      <NavLink 
        title={"Načini plaćanja"}
        path={`${PageRoute.help}/${HelpingRoutes.paymentMethods}`}
      />

      <NavLink
        title={"Pravila za predaju oglasa"}
        path={`${PageRoute.help}/${HelpingRoutes.instructionsForUse}`}
      />
      <NavLink
        title={"Često postavljana pitanja"}
        path={`${PageRoute.help}/${HelpingRoutes.faq}`}
      />

    </Col>

    <Col xs={24} sm={24} md={12} lg={12} xl={12} className={styles.column}>
      <NavLink
        title={"Pravila o privatnosti"}
        path={`${PageRoute.help}/${HelpingRoutes.privacyPolicy}`}
      />

      <a
        href={HelpingRoutes.index}
        target="_blank"
      >
        {"Index.hr"}
      </a>

    </Col>
  </Row>
);

export default HelpSectionDesktop;



// WEBPACK FOOTER //
// ./src/components/Footer/HelpSectionDesktop/HelpSectionDesktop.tsx